import { DtoPrecioEspecialidad } from "../../../../app/Domain/DtoPrecioEspecialidad";
import { EntityParams } from "../Domain/EntityParams";
import { RepositoryMain } from "../Domain/RepositoryMain";

export class UseCaseSelectPrecioEspecialidad {
    private repository: RepositoryMain;

    constructor(_repository: RepositoryMain) {
        this.repository = _repository;
    }

    public async exec(params: EntityParams): Promise<DtoPrecioEspecialidad[]> {
        return await this._exec(params);
    }

    private async _exec(params: EntityParams): Promise<DtoPrecioEspecialidad[]> {
        return await this.repository.selectPrecioEspecialidad(params);
    }
}